import isEqual from 'lodash/isEqual';
import { createContext, Dispatch, SetStateAction, useContext, useMemo, useState } from 'react';

import { DAYS_OF_THE_WEEK } from 'src/config';

interface PlaylistFilterContext {
  startDate?: string;
  endDate?: string;
  dailyStartTime?: string;
  dailyEndTime?: string;
  daysOfWeek: (keyof typeof DAYS_OF_THE_WEEK)[];
  statuses?: string[];
}

const PlaylistFilterContext = createContext({
  playlistFilterValues: {} as PlaylistFilterContext,
  setPlaylistFilterValues: {} as Dispatch<SetStateAction<PlaylistFilterContext>>,
});

const noFiltersApplied: PlaylistFilterContext = {
  startDate: undefined,
  endDate: undefined,
  dailyStartTime: undefined,
  dailyEndTime: undefined,
  daysOfWeek: [],
  statuses: [],
};

export const usePlaylistFilterContext = () => {
  const { playlistFilterValues, setPlaylistFilterValues } = useContext(PlaylistFilterContext);

  const [contextValue, setContextValue] = useState<PlaylistFilterContext>({
    startDate: undefined,
    endDate: undefined,
    dailyStartTime: undefined,
    dailyEndTime: undefined,
    daysOfWeek: [],
    statuses: [],
  });

  const hasFiltersApplied = useMemo(() => {
    return !isEqual(playlistFilterValues, noFiltersApplied);
  }, [playlistFilterValues]);

  const handleClearFilters = () => {
    setPlaylistFilterValues(noFiltersApplied);
  };

  const playlistDefaultValueForContextProvider = {
    playlistFilterValues: contextValue,
    setPlaylistFilterValues: setContextValue,
  };

  return {
    playlistDefaultValueForContextProvider,
    playlistFilterValues,
    setPlaylistFilterValues,
    handleClearFilters,
    hasFiltersApplied,
    PlaylistFilterContext,
  };
};
